module.exports = __webpack_public_path__ + "img/HFC_Bank.5507533b.jpg";